export default "__VITE_ASSET__Sn1VSxck__"